module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "top_box"
  }, [_c('div', {
    staticClass: "apply_btn",
    on: {
      "click": function($event) {
        return _vm.linkto100()
      }
    }
  }, [_vm._v("查看100部入围决赛的课程")])]), _vm._v(" "), _c('div', {
    staticClass: "center_box"
  }, [_c('div', {
    staticClass: "nav_box"
  }, _vm._l((this.menuData), function(item, index) {
    return _c('div', {
      key: index,
      class: {
        act: (_vm.isActive == item.value ? true : false)
      },
      on: {
        "click": function($event) {
          _vm.isActive = item.value;
          _vm.currentComp = item.comp
        }
      }
    }, [_vm._v("\n      " + _vm._s(item.name) + "\n      ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "center_nr_box"
  }, [_c(_vm.currentComp, {
    tag: "introduce"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-def53c3c"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 505
// module chunks = 1